import {Grid} from '@yandex-delivery/blocks'
import {HeaderButton} from '@yandex-delivery/order-layout-blocks'
import React from 'react'

export type NavLink = {
  label: string
  links: {href: string; label: string; rel?: string; target?: string}[]
}

export default function NavLinks({navLinks}: {navLinks: NavLink[]}) {
  return (
    <Grid alignItems="flex-start" container>
      {navLinks.map(({label, links}) => (
        <Grid key={label} direction="column" container item xs>
          <Grid item xs>
            <HeaderButton size="s" variant="pseudo" active transparent>
              {label}
            </HeaderButton>
            {links.map(({label: linkLabel, ...linkProps}) => (
              <Grid key={linkLabel} item xs>
                <HeaderButton {...linkProps} size="s" variant="pseudo" transparent>
                  {linkLabel}
                </HeaderButton>
              </Grid>
            ))}
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}
